
        function toggleReadMore() {
            const descriptionText = document.getElementById('descriptionText');
            const readMoreBtn = document.getElementById('readMoreBtn');
            
            if (descriptionText.classList.contains('collapsed')) {
                descriptionText.classList.remove('collapsed');
                descriptionText.style.maxHeight = 'none';
                readMoreBtn.textContent = 'Read Less';
            } else {
                descriptionText.classList.add('collapsed');
                descriptionText.style.maxHeight = '4.8em';
                readMoreBtn.textContent = 'Read More';
            }
        }


document.addEventListener("DOMContentLoaded", function () {
  const accordionHeaders = document.querySelectorAll(".accordion-header");

  accordionHeaders.forEach((header) => {
    header.addEventListener("click", function () {
      const accordionItem = this.parentElement;
      const content = accordionItem.querySelector(".accordion-content");
      const isActive = accordionItem.classList.contains("active");

      // Close all accordion items
      document.querySelectorAll(".accordion-item").forEach((item) => {
        item.classList.remove("active");
        const itemContent = item.querySelector(".accordion-content");
        itemContent.style.maxHeight = "0px";
      });

      // Open clicked item if it wasn't active
      if (!isActive) {
        accordionItem.classList.add("active");
        // Small delay to ensure the close animation completes first
        setTimeout(() => {
          content.style.maxHeight = content.scrollHeight + "px";
        }, 10);
      }
    });
  });
});
